import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';

import { EffectiveFloorplan } from '../../utility/models/effective-floorplan';
import { SettingsService } from '../../utility/services/settings.service';
import { ThemeService } from '../../utility/services/theme.service';
import { ViewModelFactoryService } from '../../utility/services/vm-factory.service';

@Component({
  selector: 'floorplan-specs',
  templateUrl: './floorplan-specs.component.html',
  styleUrls: ['./floorplan-specs.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FloorplanSpecsComponent implements OnInit, OnChanges {
  @Input() fp: EffectiveFloorplan;
  @Input() forceNonCollapsible = false;
  @Input() showPrice = true;
  isOpen = false;
  isCollapsible = false;

  constructor(
    private settingsService: SettingsService,
    private vmFactory: ViewModelFactoryService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    this.isCollapsible = this.settingsService.get('DetailsCollapsed');
    if (!this.isCollapsible) this.isOpen = true;
    if (this.forceNonCollapsible) {
      this.isCollapsible = false;
      this.isOpen = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.fp && !changes.fp.isFirstChange && this.fp) {
      this.vmFactory.setupSpecCounts(this.fp);
    }

    if (this.themeService.hideFloorCount) this.fp.FloorCount = null;
  }

  toggleState() {
    this.isOpen = !this.isOpen;
  }

  handleBlur() {
    if (this.isCollapsible) this.isOpen = false;
  }
}
